import {Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core";

const commonStyles = {
    border: 0,
    width: '48px',
    height: '48px',
    display: 'inline-block',
    cursor: 'pointer',
    verticalAlign: 'middle',
    margin: '2% 2.5%'
}
const useStyles = makeStyles(theme => ({
    instagram: {
        ...commonStyles,
        background: `transparent url('/static/images/icon_instagram.png') no-repeat center center / 100% 100%`,
        [theme.breakpoints.only("xs")]:{
            width: '24px',
            height: '24px',
        }
    },
    facebook: {
        ...commonStyles,
        background: `transparent url('/static/images/icon_facebook.png') no-repeat center center / 100% 100%`,
        [theme.breakpoints.only("xs")]:{
            width: '24px',
            height: '24px',
        }
    },
    youtube: {
        ...commonStyles,
        background: `transparent url('/static/images/icon_youtube.png') no-repeat center center / 100% 100%`,
        width: '220px',
        [theme.breakpoints.only("xs")]:{
            height: '24px',
            width: '120px',
        }
    }
}))

function Socials() {

    const classes = useStyles();

    return <Grid container spacing={0} id={"footerSection"}>
        <Grid item sm={4} xs={false}>&nbsp;</Grid>
        <Grid item xs={12} sm={4}>
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <a target={'_blank'} rel="noreferrer" href={'https://www.instagram.com/cremosso_romania/?hl=en'} className={`${classes.instagram}  link-social`}>&nbsp;</a>
                    <a target={'_blank'} rel="noreferrer" href={'https://www.facebook.com/CremossoRomania/'} className={`${classes.facebook}  link-social`}>&nbsp;</a>
                    <a target={'_blank'} rel="noreferrer" href={'https://www.youtube.com/channel/UC0XIO0_z-fQQbbXYXoZz6DA'} className={`${classes.youtube} link-social`}>&nbsp;</a>
                </Grid>
            </Grid>
        </Grid>
        <Grid item sm={4} xs={false}>&nbsp;</Grid>
    </Grid>
}

export default Socials;
